<template>
    <div>
        <div class="c-banner c-banner-small n-col-1 n-border-box n-overflow-hidden">
            <NImage class="c-banner-image n-col-1 n-h-1"
                    type="cover"
                    :src="require('@/assets/image/banner.jpg')">
            </NImage>

            <div class="c-banner-text n-col-1 n-p-3">
                <h1 class="n-c-1 c-max-width n-text-center n-m-auto n-mb-1 c-f-1 n-f-1">{{ LAN.welcome }}</h1>
            </div>
        </div>

        <div class="c-max-width n-m-auto n-mt-3 n-plr-2">
            <a-row :gutter="[20, 0]">
                <a-col :span="24"
                       :lg="6">
                    <div v-if="loading"
                         class="n-bg-1 n-p-2 n-pb-4 n-flex n-flex-dr-c n-flex-a-c">
                        <div class="thumb n-flex-s n-mb-3 n-skeleton"></div>
                        <div class="n-skeleton n-skeleton-text n-ptb-3 n-mt-3 n-col-1"></div>
                        <div class="n-skeleton n-skeleton-text n-ptb-3 n-mt-3 n-col-1"></div>
                        <div class="n-skeleton n-skeleton-text n-ptb-3 n-mt-3 n-col-1"></div>
                    </div>

                    <div v-else>
                        <div class="n-bg-1 n-plr-2 n-pt-2 n-flex n-flex-dr-c n-flex-a-c"
                             :class="data.isAnnualIssue == 1 ? 'n-pb-4' : ''">
                            <a href="javascript:;"
                               class="n-c-4 n-f-6 n-f-normal n-m-0 c-hover n-pointer n-text-center c-tab-link c-tab-link-event"
                               @click="goHome">{{
                                data.name }}
                            </a>

                            <div class="thumb n-flex-s n-mt-2 n-border-3">
                                <NImage class="thumb-image n-col-1 n-h-1"
                                        type="cover"
                                        zoomView
                                        :src="data.coverPicture"></NImage>
                            </div>
                        </div>

                        <div class="n-bg-1 n-plr-2 n-ptb-2 n-flex n-flex-dr-c n-flex-a-c">
                            <a href="javascript:;"
                               class="n-block n-c-4 n-f-6 c-tab-link c-tab-link-event n-f-normal n-m-0 n-mt-1 n-mb-2 n-text-center c-hover-line n-pointer c-link"
                               @click="goHome">{{ LAN.journal.journalHome }}</a>
                        </div>
                    </div>
                </a-col>
                <a-col :span="24"
                       :lg="18">
                    <div class="n-flex n-flex-a-c n-flex-j-sb n-mb-2">
                        <div class="n-mr-2 search-container n-flex n-flex-a-c">
                            <a-input-search v-model:value="keyword"
                                            enter-button
                                            allowClear
                                            size="large"
                                            :placeholder="LAN.nui.common.pleaseEnterKeyword"
                                            @search="searchData" />
                        </div>

                        <a-button type="primary"
                                  shape="round"
                                  v-if="canBack()"
                                  @click="$router.go(-1)">
                            <template #icon>
                                <LeftOutlined />
                            </template>
                            {{ LAN.common.back }}
                        </a-button>
                    </div>

                    <h3 class="n-c-4 n-f-bold n-mtb-0 n-flex-g n-flex-s"> {{ LAN.journal.firstArticles }}</h3>

                    <div class="n-flex n-flex-a-c n-flex-w n-flex-j-sb">
                        <div class="n-flex n-flex-a-c">
                            <div class="n-flex n-flex-a-c n-ptb-2 n-mr-4">
                                <span class="title-icon n-flex n-flex-a-c n-flex-j-c n-mr-2 n-c-1 n-radius-3">
                                    <EditOutlined class="n-flex-s" />
                                </span>
                                <h1 class="n-c-4 n-f-bold n-m-0">{{ LAN.journal.contents }}</h1>
                            </div>
                            <span style="padding-top: 1px">{{ LAN.journal.totalI.replace('|T|', this.contents?.length ||
                                0) }}</span>
                        </div>

                        <a class="n-c-base n-ml-3 c-hover-line n-text-right c-tab-link c-tab-link-event"
                           :href="data.externalSiteUrl"
                           target="_blank"
                           v-if="data.externalSiteUrl && data.onlyExternalPublish == 0">{{
                                LAN.journal.readOn.replace('|SITE|',
                                    data.externalSiteName).replace('|NAME|', data.name) }}</a>

                    </div>

                    <div v-if="loading">
                        <ul class="n-ul n-p-0 list n-bg-1 n-mt-2">
                            <li class="n-b-line n-pointer n-p-4"
                                v-for="item in 3"
                                :key="item">
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-col-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                            </li>
                        </ul>
                    </div>

                    <div v-else-if="contents?.length > 0"
                         class="n-bg-1 n-mt-2">
                        <ul class="n-ul n-p-0 list">
                            <template v-for="item in contents"
                                      :key="item">
                                <div class="n-flex n-flex-a-c"
                                     style="background-color: #f7f7f7;"
                                     v-if="(item.groupTitle || '') != ''">
                                    <div class="n-flex n-flex-a-c n-ptb-1">
                                        <i class="n-c-4 n-m-0">
                                            <h3 style="color:#A51B35;">{{ item.groupTitle || '' }}</h3>
                                        </i>
                                    </div>
                                </div>

                                <li class="c-hover">
                                    <router-link :to="{ name: 'JFirstDetail', params: { cid: item.id } }"
                                                 class="n-block c-tab-link c-tab-link-event n-b-line n-pointer n-p-2">
                                        <p class="n-block n-f-6 n-c-4 n-f-bold c-hover-target n-m-0"
                                           v-html="parseHilight(item.title, keyword)"></p>

                                        <span class="n-block n-c-4">{{ parseAuthors(item.authors) }}</span>

                                        <div class="n-flex n-flex-a-e n-flex-j-sb">
                                            <span class="n-block n-c-base n-mr-2"
                                                  v-if="item.totalPages">{{ item.totalPages }}
                                                {{ LAN.journal.pages }}</span>
                                            <span v-else></span>

                                            <span class="n-c-green n-f-bold n-flex-g"
                                                  v-if="item.isOpenAccess">{{
                                                LAN.journal.openAccess
                                                }}</span>

                                            <div class="n-block n-col-3 n-text-right">
                                                <a-button type="primary">{{ LAN.common.view }}</a-button>
                                            </div>
                                        </div>
                                    </router-link>
                                </li>
                            </template>
                        </ul>

                    </div>

                    <a-row :gutter="[15, 15]"
                           class="n-col-1"
                           v-else>
                        <a-col class="n-bg-1 n-ptb-3"
                               span="24">
                            <a-empty :description="LAN.journal.noContents"></a-empty>
                        </a-col>
                    </a-row>

                    <span class="n-f-2 n-c-2 n-mt-2 n-block"
                          v-if="contentAll.updateTimeGmt">{{ LAN.common.updateTime
                        }}: {{
                        contentAll.updateTimeGmt }} ({{ formatDateToLocalTime(contentAll.updateTimeGmt) }})
                    </span>
                </a-col>
            </a-row>
        </div>
    </div>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import { EditOutlined } from '@ant-design/icons-vue';
    import NImage from '@/components/nui/NImage/NImage.vue'
    import Breadcrumb from '@/components/Breadcrumb.vue'
    import nui from '@/assets/script';

    export default {
        name: 'BDetail',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loading: false,
                data: {},

                contentsCache: [],
                contentAll: {},
                contents: [],
                keyword: '',
                volumeId: '',
                issueId: ''
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.loadData()
            },
            searchData () {
                this.contents = this.extend([], this.contentsCache.filter(item => {
                    return item.title.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0
                }))
            },
            loadData () {
                this.loading = true;

                let periodicalId = this.$route.query.jid || '';

                var a = this.request(this.API.journalList, {
                    requestId: 'journalList',
                    params: { id: periodicalId }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE && res.data && res.data.id) {
                        this.data = res.data || {};
                    }
                    else {
                        this.$router.replace({ name: '404page' });
                    }
                }).catch(() => {
                    this.loading = false;
                })

                var b = this.request(this.API.journalFirst, {
                    requestId: 'journalFirst',
                    params: { periodicalId: periodicalId }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE
                        && res.data
                        && res.data.periodicalId
                    ) {
                        let data = res.data.content;

                        let groupTitle = "";
                        (data || []).forEach(element => {
                            let groupTitleTemp = (element.cmsItemSubTypeIndexText || '') || (element.amsaItemGroupText || '');

                            let articleType = element.articleType || '';
                            switch (articleType) {
                                case 'erratum':
                                    groupTitleTemp = 'Errata';
                                    break;
                                case 'supplement':
                                    groupTitleTemp = 'Supplements';
                                    break;
                                case 'back-matter':
                                    groupTitleTemp = 'Back matter';
                                    break;
                            }

                            if ((groupTitleTemp || '') != '' && groupTitleTemp != groupTitle) {
                                element.groupTitle = groupTitleTemp;
                                groupTitle = groupTitleTemp;
                            }
                        });

                        this.contents = data;
                        this.contentsCache = data;

                        this.contentAll = res.data;
                    }
                    else {
                        this.$router.replace({ name: '404page' });
                    }
                }).catch(() => {
                    this.loading = false;
                })

                Promise.all([a, b]).then(() => {
                    this.loading = false
                    this.$nextTick(() => {
                        this.parseMathJax()
                    })
                }).catch((err) => {
                    this.loading = false

                    if (err.code != 'ERR_CANCELED') {
                        this.$router.replace({ name: '404page' });
                    }
                })
            },
            goHome () {
                if (this.data.isAnnualIssue == 1) {
                    this.$router.push({ name: 'bookSuccessionList', query: { id: this.data.serialId } })
                } else {
                    this.$router.push({ name: 'journalList', query: { id: this.$route.query.jid } })
                }
            },
            parseAuthors (data = []) {
                var res = JSON.parse(JSON.stringify(data.map(item => item.fullName)))

                if (res.length > 1) {
                    if (res.length == 2) {
                        return res.join(' and ')
                    } else {
                        res[res.length - 1] = 'and ' + res[res.length - 1]
                        return res.join(', ')
                    }
                } else {
                    return res.join(', ')
                }
            }
        }),
        components: {
            NImage,
            Breadcrumb,
            EditOutlined
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .thumb {
        width: 227px;
        height: 320px;

        .thumb-image {
            transition: all 0.3s;
        }
    }

    .title-icon {
        background-color: rgb(255, 226, 186);
        color: rgb(255, 162, 66);
        padding: 5px;
    }

    .list {
        & > li {
            position: relative;

            i {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background-image: $linear;
                background-color: transparent;
                opacity: 0;
                transition: all 0.3s;
            }

            &:hover {
                h1,
                p {
                    color: $color-base;
                }

                i {
                    opacity: 1;
                }
            }
        }
    }
</style>